export const emojis = [
 
  "😀", "😁", "😂", "🤣", "😃", "😄", "😅", "😆",
  "😉", "😊", "😋", "😎", "😍", "😘", "🥰", "😗",
  "😙", "😚", "🙂", "🤗", "🤔", "😐", "😑", "😶",
  "🙄", "😏", "😣", "😥", "😮", "🤐", "😯", "😪",
  "😫", "🥱", "😴", "😌", "😛", "😜", "🤪", "😝",
  "🤤", "😒", "😞", "😔", "😟", "😢", "😭", "😤",
  "😠", "😡", "🤬", "🤯", "😳", "🥺", "😱", "😰",
  "😨", "😧", "😦", "😯", "😲", "🤯", "😬", "🤥",
  "🤫", "🤭", "🫣", "🫢", "😶‍🌫️",

  "❤️", "🩷", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎",
  "💔", "❣️", "💕", "💞", "💓", "💗", "💖", "💘", "💝", "💟",
  "👍", "👎", "👊", "✊", "🤛", "🤜", "👏", "🙌", "🫶",
  "🙏", "🤝", "👌", "🤏", "✌️", "🤞", "🤟", "🤘", "🤙",
  "👋", "🤚", "✋", "🖖", "☝️", "👆", "👇", "👉", "👈",

  "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐨", "🐯",
  "🦁", "🐮", "🐷", "🐸", "🐵", "🐔", "🐧", "🐦", "🐤", "🐣",
  "🐥", "🐺", "🦄", "🐝", "🐛", "🦋", "🐞", "🐢", "🐍", "🦖",

  "🍎", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓", "🍒", "🍍",
  "🥭", "🥝", "🍅", "🥥", "🥕", "🌽", "🥔", "🍟", "🍕",
  "🍔", "🌭", "🍿", "🍩", "🍪", "🍰", "🎂", "🍫", "🍬",
  "🍭", "☕", "🍵", "🧃", "🍺", "🍻", "🥂", "🍷", "🥤",

  "🚗", "🚕", "🚙", "🚌", "🏍️", "🚲", "✈️", "🚀", "🚁",
  "⛵", "🚤", "🚉", "🚄", "🚅", "🏠", "🏡", "🏢", "🏦", "🏥", "🏫",

  "⚽", "🏀", "🏈", "⚾", "🎾", "🏐", "🎱", "🥏", "🏓", "🎯",
  "🎮", "🎲", "🎵", "🎶", "🎤", "🎧", "🎸", "🎹", "🎺", "🎷",
  "🎻", "🎬", "🎨", "🖌️", "✏️", "💡", "💻", "📱", "⌚", "🖥️",

  "💬", "🗨️", "💭", "💤", "💢", "💥", "💫", "💦", "💨", "✨",
  "🌟", "🔥", "💯", "✅", "❌", "⚠️", "⛔", "🔞", "🚫", "🔒",
  "🔓", "🔑", "🗝️", "❤️‍🔥", "❤️‍🩹", "💘", "💌", "📸", "🎁", "🎈",
];
